<footer class="site-footer">
  <div class="brand">
    <span class="brand-name">CENTRAL SLAYERS</span>
    <span class="tagline">{{ tagline() }}</span>
  </div>
  <div class="footer-links">
    @for (link of links; track link) {
      <a href="#" (click)="$event.preventDefault()">{{ link }}</a>
    }
  </div>
</footer>
